import { getReferencePrefixByCountry } from 'utilities/multiLanguageHelper';
import { getHomeAddress } from './getHomeAddress';

const setCellPhone = cellPhone => {
    return cellPhone.replace(/\s/g, '');
};

const setHomeAddress = userProfile => {
    const homeAddress = getHomeAddress(userProfile);
    homeAddress['addressNumber'] = userProfile.addressNumber;

    return homeAddress;
};

const setJointHolderDecision = (isJointHolder, jointHolderDecision) => {
    return isJointHolder ? null : jointHolderDecision || false;
};

const setNationality = (shouldShowNationalityField, nationality) => {
    return shouldShowNationalityField ? nationality : undefined;
};

const setPassport = passport => {
    return passport ? passport.replace(/\s+/g, '') : undefined;
};

export const getAllData = userProfile => {
    const {
        birthCountry,
        birthPopulation,
        birthProvince,
        cellPhone,
        cellphonePrefix,
        gender,
        isJointHolder,
        jointHolderDecision,
        nationality,
        passport,
        shouldShowNationalityField,
    } = userProfile;

    const data = {
        birthCountry,
        birthPopulation,
        birthProvince,
        cellPhone: setCellPhone(cellPhone),
        cellphonePrefix: cellphonePrefix || getReferencePrefixByCountry(),
        gender,
        homeAddress: setHomeAddress(userProfile),
        jointHolderDecision: setJointHolderDecision(isJointHolder, jointHolderDecision),
        nationality: setNationality(shouldShowNationalityField, nationality),
        passport: setPassport(passport),
    };

    return data;
};
